// removed by extract-text-webpack-plugin
module.exports = {"container":"_2sVkwVQV_PC99rhWhNh8Cy","header":"ZGTSNv7c2gvIPh7ZWZkch","form":"_1V1hh5jQL5rmR7vCFan1jW","formItem":"_1ZTg3VT5ef8zinAf6I2KFi","button":"_26QCL5DghrEGdHSJH1_1KU"};


//////////////////
// WEBPACK FOOTER
// ./src/Login.css
// module id = 541
// module chunks = 0